/**
 * Default entry policy: admin-only.
 */
export const DEFAULT_ENTRY_ANY_OF_ROLES = ['admin'];
/**
 * Check if user can enter the app based on claims and policy.
 *
 * Fail closed: returns false if:
 * - activeOrg is missing
 * - orgs is missing
 * - activeOrg is not in orgs
 * - user has no roles in activeOrg
 * - user's roles don't match any of entryAnyOfRoles
 *
 * @param claims - User claims from Firebase token
 * @param policy - App-specific policy
 * @returns true if user can enter, false otherwise
 */
export function canEnterApp(claims, policy) {
    // Fail closed: no claims
    if (!claims)
        return false;
    const { orgs, activeOrg } = claims;
    // Fail closed: missing activeOrg
    if (!activeOrg)
        return false;
    // Fail closed: missing orgs structure
    if (!orgs)
        return false;
    // Get user's roles in activeOrg
    const orgData = orgs[activeOrg];
    if (!orgData)
        return false;
    const userRoles = orgData.roles;
    if (!Array.isArray(userRoles) || userRoles.length === 0)
        return false;
    // Check if user has any of the required roles
    return policy.entryAnyOfRoles.some((requiredRole) => userRoles.includes(requiredRole));
}
